require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/fn/symbol/iterator.js
// module id = 3
// module chunks = 0